import { useMediaQuery } from "react-responsive";

export function useIsDesktopOrTabletScreen() {
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 717px)',
  });

  return isDesktopOrLaptop;
}